<template>
  <div class="chat">
    <div class="messages">
        <div v-for="message in messages" :class="['message', message.from]" :key="message.id">
            <span class="response" v-html="message.text"></span>
        </div>
        <div v-if="typing" class="message model">
            <img src="/static/ai-robot.gif" alt="typing" width="24">
        </div>
    </div>

    <div class="input">
        <textarea class="chat-input" v-model="message" type="text" @keyup.enter="sendMessage" autofocus :placeholder="`Write a message...`" style="resize: none;" />
        <button class="chat-button" @click="sendMessage">
            <img src="/static/send.png" alt="send">
        </button>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

import config from '../config';

export default {
    name: 'Chat',
    props: {
        model: Object
    },
    data () {
        return {
            messages: [],
            message: '',
            typing: false,
            sessionId: uuid()
        }
    },
    methods: {
        getReply(message) {
            this.typing = true;

            const token = localStorage.getItem('token');

            const body = {
                message,
                session_id: this.sessionId
            }

            fetch(`${config.api}/models/interaction/${this.model.id}/chat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(body)
            })
            .then(response => response.json())
            .then(data => {
                this.messages.push({
                    id: uuid(),
                    text: data.response,
                    from: 'model',
                    timestamp: new Date(data.created_at).toLocaleDateString('nl-NL')
                });
            })
            .catch(error => {
                if (error.message === '403') {
                    this.$router.push('/login');
                }
                else {
                    this.messages.push({
                        id: uuid(),
                        text: 'Sorry, I am not able to reply right now.',
                        from: 'model',
                        timestamp: new Date().toLocaleDateString('nl-NL')
                    });
                    console.error('Error:', error);
                }
            })
            .finally(() => {
                this.typing = false;
            });
        },
        sendMessage () {
            if (this.message.replace(/\s/g, '').length === 0)
                return;
            if (this.typing)
                return;

            const message = this.message;

            this.messages.push({
                id: uuid(),
                text: this.message,
                from: 'user',
                timestamp: new Date().toLocaleDateString('nl-NL')
            });
    
            this.message = '';

            this.getReply(message);
        }
    },
    mounted() {
        this.messages.push({
            id: uuid(),
            text: `Hi, I'm ${this.model.name}, your ${this.model.analyzer_type.toUpperCase()} model. Start basic chat interaction here.`,
            from: 'model',
            timestamp: new Date().toLocaleDateString('nl-NL')
        });
    },
    watch: {
        messages () {
            this.$nextTick(() => {
                const messages = this.$el.querySelector('.messages');
                messages.scrollTo({
                    top: messages.scrollHeight,
                    behavior: 'smooth'
                });
            });
        }
    }
}
</script>

<style scoped>

.chat {
    width: 400px;
    background-color: rgb(235, 235, 235);
    border-radius: 8px;
    padding: 20px;

}

.messages {
    height: 300px;
    overflow-y: scroll;

    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;
    scrollbar-width: none;

}

.messages::-webkit-scrollbar {
    display: none;
}

.message {
    padding: 10px;
    margin: 10px 0;
    border-radius: 8px;
    font-size: 14px;
}

.message.user {
    background-color: rgb(255, 255, 255);

    align-self: flex-end;
}

.message.model {
    background-color: rgb(255, 255, 255);
    border: 2px solid rgb(131, 17, 176);
    color: black;

    align-self: flex-start;
}


.input {
    position: relative;
}

.chat-input {
    width: calc(100% - 20px);
    padding: 11px 20px 11px 11px;
    border-radius: 20px;
    border: none;
    margin-right: 10px;
    outline: rgb(131, 17, 176);
}

.chat-button {
    position: absolute;
    right: 6px;
    top: 6px;
    padding: 10px;
    border-radius: 50%;
    border: none;
    background-color: rgb(79, 79, 79);
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.chat-button:hover {
    background-color: rgb(59, 59, 59);

}

.chat-button img {
    position: absolute;
    top: 10px;
    right: 9px;
    width: 10px;
    height: 10px;
    filter: invert(100%);
}


</style>


// WEBPACK FOOTER //
// src/components/Chat.vue